const ordinais = ["1º", "2º", "3º", "4º", "5º", "6º", "7º", "8º", "9º", "10º", "11º", "12º", "13º", "14º", "15º"];

export const CORTE_OPTIONS = ordinais.map((ordinal) => `${ordinal} corte`);
